import React, { Component } from 'react';
import { connect } from 'react-redux';
import UserManagedSearchComponent from './UserManagedSearchComponent';
import UserManagedListComponent from './UserManagedListComponent';
import UserManagedPopModifyComponent from './UserManagedPopModifyComponent';
import UserManagedPopResetPasswordComponent from './UserManagedPopResetPasswordComponent';
import {
  getRoleMaster,
  setInitMessage,
} from '../../actions/CommonAction';
import { setRoleList } from '../../actions/UserManagedAction';
import './UserManagedComponent.css';

/**
 * ユーザ管理画面全体
 */
class UserManagementComponent extends Component {
  async componentDidMount() {
    // Google Analytics
    window.gtagPageview();

    const {
      getRoleMasterAct,
      setRoleListAct,
    } = this.props;

    // 権限マスタ取得API呼出し
    const ret = await getRoleMasterAct();
    if (ret && ret.role_list) {
      // 権限マスタを一時保存領域に保持
      setRoleListAct(ret.role_list);
    }
  }

  componentWillUnmount() {
    const { setInitMessageAct } = this.props;
    setInitMessageAct();
  }

  render() {
    return (
      <div className="usermanagement">
        <div className="container">
          <div className="container1">
            <UserManagedSearchComponent />
          </div>
          <div className="container2">
            <UserManagedListComponent />
          </div>
        </div>
        <UserManagedPopResetPasswordComponent />
        <UserManagedPopModifyComponent />
      </div>
    );
  }
}

export default connect(
  null,
  (dispatch) => ({
    getRoleMasterAct: () => dispatch(getRoleMaster()),
    setRoleListAct: (arr) => dispatch(setRoleList(arr)),
    setInitMessageAct: () => dispatch(setInitMessage()),
  }),
)(UserManagementComponent);
